import { Stack, StackProps, styled, Typography } from "@mui/material";

type IAppointmentStyle = {
    color?: string;
}

export const TypographyToday = styled(Typography)(() => ({
  borderRight: "0.1rem solid",
  marginRight: "0.4rem",
  paddingRight: "0.4rem"
}));

export const DayTitle = styled(Stack)(({ theme }) => ({
  "> p": {
    color: theme.customColors.exploreCardText
  },
  "&:after": {
    borderBottom: `0.125rem solid ${theme.customColors.border}`,
    borderRadius: "50rem",
    content: "''",
    display: "block",
    height: "0.125rem",
    margin: "0.25rem 0.5rem",
    position: "relative"
  },
  alignItems: "start",
  display: "flex",
  flexDirection: "column"
}));

export const AgendaWidgetContainerStyle = styled("div")(() => ({
  gap: 0,
  padding: "0rem 0.5rem"
}));

export const AppointmentList = styled("ul")(({ theme }) => ({
  "&:after": {
    borderBottom: `0.125rem solid ${theme.customColors.border}`,
    borderRadius: "50rem",
    content: "''",
    display: "block",
    height: "0.125rem",
    margin: "0.25rem 0.5rem",
    position: "relative"
    // width: "21.8rem"
  },
  listStyle: "none",
  marginBottom: "0.5rem",
  marginTop: "0.5rem",
  paddingLeft: 0
}));

export const Appointment = styled("li")<StackProps & IAppointmentStyle>(({ theme, color }) => ({
  "& > div": {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem"
  },
  "&:before": {
    background: color,
    borderRadius: "50rem",
    content: "''",
    marginRight: "0.5rem",
    width: "2px",
    display: "block",
    flexShrink: 0
  },
  ":hover": {
    backgroundColor: `rgba(${theme.customColors.backgroundSecondaryHover})`, 
    // backgroundColor: theme.customColors.backgroundSecondaryHover, //TODO ripristinare
    cursor: "pointer"
  },
  display: "flex",
  flexDirection: "row",
  borderRadius: "0.5rem",
  padding: "0.5rem 0.5rem"
}));

export const TypographyAppointmentTitle = styled(Typography)<StackProps & IAppointmentStyle>(({
  color
}) => ({
  color: color,
  fontSize: "0.75rem",
  fontWeight: "700",
  lineHeight: "0.75rem"
}));

export const TypographyAppointmentInfo = styled(Typography)<StackProps & IAppointmentStyle>(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "0.75rem",
  fontWeight: "500",
  lineHeight: "0.75rem"
}));

export const TypographyAppointmentHours = styled(Typography)<StackProps & IAppointmentStyle>(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "0.75rem",
  fontWeight: "400",
  lineHeight: "0.75rem"
}));

export const TypographyTodayAgenda = styled("div")<StackProps & IAppointmentStyle>(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "0.75rem",
  fontWeight: "400",
  lineHeight: "0.75rem",
  display:"flex"
}));

export const TodayLabel = styled(Stack)<StackProps>(({ theme }) => ({
  "&:after": {
    borderBottom: `0.125rem solid ${theme.customColors.border}`,
    borderRadius: "50rem",
    content: "''",
    display: "block",
    height: "0.125rem",
    position: "relative"
  }

}));
